import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import ResetPasswordForm from './components/ResetPasswordForm';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { Loader } from 'ncoded-component-library';
import aisleOptixLogo from '../../../../../../public/aisle-optix-logo.png';
import { useLocation } from 'react-router-dom';

import './ResetPassword.styles.scss';
import './ResetPassword.styles.responsive.scss';

type ResetPasswordProps = {
  className?: string;
};

const ResetPassword: React.FC<ResetPasswordProps> = (props) => {
  const { className } = props;

  const location = useLocation();
  const {
    state: { forgotPassword },
  } = location;

  const { currentUser, changePassword, resetPassword, loading } =
    useContext(CurrentUserContext);

  const classes = classNames('hhsa-reset-password', className);

  const initialValues = useMemo(
    () => ({ userId: currentUser?.id }),
    [currentUser?.id],
  );

  return (
    <div className={classes}>
      {loading ? (
        <Loader color="#007cb9" />
      ) : (
        <>
          <img
            className="hhsa-reset-password__logo"
            src={aisleOptixLogo}
            alt="logo"
          />

          <ResetPasswordForm
            initialValues={initialValues}
            forgotPassword={forgotPassword}
            onSubmit={forgotPassword ? changePassword : resetPassword}
            inProgress={loading}
          />
        </>
      )}
    </div>
  );
};

export default ResetPassword;
